module.exports = "//s1.igetcool.com/mall-h5/img/h5_coupon_punch_img_yhq.6e6289dc.png";